<h2 mat-dialog-title>
    Nos simulateurs validés et certifiés ✅
</h2>
<div mat-dialog-content>
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
    <div class="row">
        <div class="col-md-12">
            <p class="text-center">
                <img src="assets/qlower.png">
            </p>
            <p>Vous pouvez avoir confiance : Les calculs et les simulations de fiscalités effectuées dans LyBox sont validés et certifiées par les fiscalistes de Qlower !</p>
            <h3>Qui est Qlower ?</h3>
            <p>
                Qlower est cabinet comptable spécialisé en immobilier, regroupant des experts-comptables et des fiscalistes.<br/>
                <br/>
                Vous cherchez un cabinet comptable pour vos investissements immobiliers ? Qlower vous accompagne à partir de 19,99€/mois seulement :<br/>
                ✅ Comptabilité et déclaration fiscale<br/>
                ✅ Logiciel de suivi de votre comptabilité et de vos biens<br/>
                ✅ Conseil patrimonial et fiscal<br/>
                <br/>
                En tant qu’utilisateur LyBox, vous bénéficiez de 20€ offerts sur votre gestion comptable en cliquant ci-dessous :
            </p>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Retour
    </button>
    <a href="https://www.qlower.com/qlower-x-lybox/" target="_blank" class="btn btn-primary float-right">
        Profiter de 20€ offerts
    </a>
</div>
